import axios from "axios";
import { API } from "../../constants";
import { toast } from "react-toastify";
export const subscribesGet = async (findBy, token) => {
  try {
    const url = `${API?.API_V1}/subscribes${findBy}`;
    const res = await axios.get(url, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    if (Array.isArray(res.data)) {
      return res.data;
    }
    return [];
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const subscribeGet = async (id, token) => {
  try {
    const url = `${API?.API_V1}/subscribe/${id}`;
    const res = await axios.get(url, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const subscribePost = async (body, token) => {
  try {
    const url = `${API?.API_V1}/subscribe/create`;

    const res = await toast.promise(
      axios.post(
        url,
        { ...body },
        { headers: { Authorization: `Bearer ${token}` } }
      ),
      {
        pending: "ກຳລັງເພີ່ມທີ່ພັກ...",
        success: {
          render() {
            return "ເພີ່ມທີ່ພັກສຳເລັດ 👌";
          },
          autoClose: 1000,
        },
        error: {
          render() {
            return "Error ບໍ່ສາມາດເພີ່ມທີ່ພັກໄດ້ 🤯";
          },
          autoClose: 1000,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const subscribePut = async (id, body, token) => {
  try {
    const url = `${API?.API_V1}/subscribe/update`;
    const res = await toast.promise(
      axios.put(
        url,
        { id: id, data: body },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      ),
      {
        pending: "ກຳລັງແກ້ໄຂທີ່ພັກ...",
        success: {
          render() {
            return "ແກ້ໄຂທີ່ພັກສຳເລັດ 👌";
          },
          autoClose: 1000,
        },
        error: "Error ບໍ່ສາມາດແກ້ໄຂທີ່ພັກໄດ້ 🤯",
      }
    );
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const subscribeDelete = async (id, token) => {
  try {
    const url = `${API?.API_V1}/subscribe/delete`;
    const res = await toast.promise(
      axios.delete(url, {
        headers: {
          authorization: `Bearer ${token}`,
        },
        data: { id: id },
      }),
      {
        pending: "ກຳລັງລົບທີ່ພັກ...",
        success: {
          render() {
            return "ລົບທີ່ພັກສຳເລັດ 👌";
          },
          autoClose: 1000,
        },
        error: "Error ບໍ່ສາມາດລົບທີ່ພັກໄດ້ 🤯",
      }
    );
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const subscribeCountGet = async (findBy, token) => {
  try {
    const url = `${API?.API_V1}/subscribe/count${findBy}`;
    const res = await axios.get(url, null, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
